import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ArchivoVariosContactos } from 'src/app/interfaces/ArchivoVariosContactosData';
import { ListaContactos } from 'src/app/interfaces/ListaContactosData';
import { ListaContactosService } from 'src/app/service/listaContactos.service';
import { LoginService } from 'src/app/service/login.service';
import { MensajesService } from 'src/app/service/message.service';

@Component({
  selector: 'app-envio-masivo-archivo',
  templateUrl: './envio-masivo-archivo.component.html',
  styleUrls: ['./envio-masivo-archivo.component.scss'],
  providers: [MessageService]
})
export class EnvioMasivoArchivoComponent implements OnInit{
  deviceUrl: string = '';
  deviceName: string = '';
  camposMensaje: ArchivoVariosContactos = {
    idCustomer: 0,
    token: '',
    opcion: '1',
    numeros: [],
    numerosTexto: '',
    nombreCampania: '',
    nombrearchivo: '',
    url: '',
    textoimagen: '',
    verificarNumeros: 'No'
  };

  validar: boolean = false;

  archivoSeleccionado: File | null = null;

  ingresoManualSeleccionado: boolean = true;
  importacionCsvSeleccionada: boolean = false;
  listaSeleccionada: boolean = false; 

  listas: ListaContactos[] = [];

  listaElegida: any;

  soloNumerosValidacion: RegExp = /^[0-9\s]+$/;

  constructor( private formBUilder: FormBuilder, private mensajesService: MensajesService, private messageService: MessageService, 
    private route: ActivatedRoute, private loginService: LoginService, private listasContactosService: ListaContactosService, 
    private router: Router, private translate: TranslateService){
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
    }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'] || '';
      const nombre = params['deviceName'] || '';
      if (token) {
        this.deviceUrl = token;
      } 
      if(nombre){
        this.deviceName = nombre;
      }
    });
    if (this.camposMensaje.opcion === '1') {
      this.ingresoManualSeleccionado = true;
    } else if (this.camposMensaje.opcion === '2') {
      this.importacionCsvSeleccionada = true;
    } else if (this.camposMensaje.opcion === '3') {
      this.listaSeleccionada = true; 
    }
    this.camposMensaje.idCustomer = this.loginService.chatCrmUser.idCustomer;
    //obter listas de contactos
    this.route.queryParams.subscribe(params => {
      const token = params['deviceUrl'] || '';
      if (token) {
        this.listasContactosService.getAllContactos(token).subscribe((listas: ListaContactos[]) => {
          this.listas = listas;
        });
      } 
    });
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  onFileSelected(event: any) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.archivoSeleccionado = fileList[0];
    }
  }

  enviarArchivo() : void{
    if(this.camposMensaje.nombreCampania === "" || this.camposMensaje.nombrearchivo === "" || this.camposMensaje.url === "" 
      || this.camposMensaje.textoimagen === ""){
        this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate.instant('ALERT_FIELDS')})
        this.validar = true;
        return;    
      }

      if (!this.deviceUrl) {
        this.messageService.add({
          severity: 'error', 
          summary: 'Error', 
          detail: this.translate.instant('SELECT_DEVICE_ERROR')
        });
        return;
      }
    // Limpiar la cadena de números de cualquier espacio en blanco adicional
    this.camposMensaje.numerosTexto = this.camposMensaje?.numerosTexto?.replace(/\s+/g, ',');

    // Remover comas duplicadas, si las hubiera
    this.camposMensaje.numerosTexto = this.camposMensaje?.numerosTexto?.replace(/,{2,}/g, ',');

    // Si la cadena comienza con una coma, eliminarla
    this.camposMensaje.numerosTexto = this.camposMensaje?.numerosTexto?.replace(/^,+/g, '');

    // Si la cadena termina con una coma, eliminarla
    this.camposMensaje.numerosTexto = this.camposMensaje?.numerosTexto?.replace(/,+$/g, '');

    // Actualizar el arreglo de números
    this.camposMensaje.numeros = this.camposMensaje?.numerosTexto?.split(',');
    
    this.camposMensaje.token = this.deviceUrl;

    if (this.listaSeleccionada) {
      this.camposMensaje.nombreLista = this.listaElegida;
    } 

    if (this.archivoSeleccionado) {
      // Llama al servicio para crear la lista, pasando la nuevaLista y el archivoSeleccionado
      this.mensajesService.enviarArchivoMuchosContactos(this.camposMensaje, this.archivoSeleccionado)
      .subscribe((response) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: this.translate.instant('FILE_SUCCESS')});
          setTimeout(()=>{this.router.navigate(['/campaigns'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
          queryParamsHandling: 'merge'})},2500)
        }, (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('FILE_ERROR')});
        });
    } else {
      console.log("No se ha seleccionado ningún archivo csv.");
      // Llama al servicio para crear la lista solo con los datos de la nuevaLista
      this.mensajesService.enviarArchivoMuchosContactos(this.camposMensaje, null)
        .subscribe(() => {
          debugger;
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: this.translate.instant('FILE_SUCCESS')});
          setTimeout(()=>{this.router.navigate(['/campaigns'], {queryParams: {deviceUrl: this.deviceUrl, deviceName: this.deviceName},
          queryParamsHandling: 'merge'})},2500)
        }, (error) => {
          this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate.instant('FILE_ERROR')})
        });
    }
  }

  cambiarOpcion(opcionSeleccionada: string, event: any) {
    if (event.target.checked) {
      this.camposMensaje.opcion = opcionSeleccionada;
      if(this.camposMensaje.opcion === '1'){
        this.importacionCsvSeleccionada = false; 
        this.listaSeleccionada = false;
        this.ingresoManualSeleccionado = true;
      } else if (this.camposMensaje.opcion === '2') {
        this.importacionCsvSeleccionada = true; 
        this.listaSeleccionada = false; 
        this.ingresoManualSeleccionado = false;
      } else if (this.camposMensaje.opcion === '3') {
        this.listaSeleccionada = true;
        this.importacionCsvSeleccionada = false;
        this.ingresoManualSeleccionado = false; 
      }
  } else {
    this.camposMensaje.opcion = '';
  }
  }

  seleccionarLista(event: any){
    const selectedId = event.target.value; // Obtener el ID seleccionado del evento
    const selectedList = this.listas.find(lista => lista.id === selectedId); // Buscar el objeto en listas con el ID seleccionado
    if (selectedList) {
        this.listaElegida = selectedList.nombre; // Asignar el nombre de la lista seleccionada a listaElegida
    } else {
        this.listaElegida = ''; // Si no se encuentra ninguna lista con ese ID, se asigna una cadena vacía
    }
    console.log(this.listaElegida);
}

regresar(deviceUrl: string, deviceName: string){
  this.router.navigate(['/campaigns'], { queryParams: { deviceUrl: this.deviceUrl, deviceName: this.deviceName },
  queryParamsHandling: 'merge'});
}

verificarSoloNumeros(texto: string): boolean {
  return this.soloNumerosValidacion.test(texto);
}
}
